import { PreviewSupportedFileType } from '$shared/constants/PreviewSupportedFileType';
import { FilePreview } from './FilePreview';

export class ImagePreview extends FilePreview<string> {
  constructor(data: string) {
    super(PreviewSupportedFileType.Image, data);
  }
}
